import React from 'react';
import {useDispatch} from "react-redux";
import {ALERT} from "@/actions/types";

interface IProps {
  postId?: number;
}

const ShareButton: React.FC<IProps> = ({ postId }) => {
  const oldSchoolCopy = async (text: string) => {
    return new Promise((res, rej) => {
      const inpt = document.createElement('textarea') as HTMLTextAreaElement;
      inpt.value = text;
      inpt.append(document.body);
      inpt.focus();
      inpt.select();
      inpt.setSelectionRange(0, 999999);
      document.execCommand("copy");
      setTimeout(() => {
        inpt.remove();
        res(true);
      }, 10);
    });
  }

  const copyToClipboard = async (text: string) => {
    return new Promise(async (res, rej) => {
      if(typeof window.navigator !== "undefined" && typeof window.navigator.clipboard !== "undefined") {
        window.navigator.clipboard.writeText(text)
            .then(async () => {})
            .catch(async () => {
              console.log('Trying with old way!');
              await oldSchoolCopy(text);
            });
      } else {
        console.log('Trying with the old way!');
        await oldSchoolCopy(text);
      }
      res(true);
    });
  }

  const dispatch = useDispatch();

  const copied = () => {
    dispatch({
      type: ALERT,
      payload: {
        message: {
          result: 1,
          message: 'لینک با موفقیت کپی شد!'
        }
      }
    })
  };

  return (
      <button type="button" onClick={() => copyToClipboard(postId ? `https://${document.location.hostname}/post/${postId}` : document.location.href).then(copied)}>
        <i className="fa fa-share-alt" />
      </button>
  );
}

export default ShareButton;
